export enum AccountInvitesTypeEnum {
  CANCELLED = 'cancelled',
  PENDING = 'pending',
  ACCEPTED = 'accepted',
  EXPIRED = 'expired',
}
